import { render, staticRenderFns } from "./AdminGames.vue?vue&type=template&id=3fd2bc44&"
import script from "./AdminGames.vue?vue&type=script&lang=js&"
export * from "./AdminGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports